import { Component, OnInit, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { IListadoCategoria } from 'modelos/src';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { ListadoCategoriasService } from '../../../../auxiliares/servicios/http/listado-categorias.service';
import { LoginService } from '../../../login/login.service';
import { MaterialModule } from '../../../../auxiliares/material.module';
import { CardHeaderComponent } from '../../../../componentes/card-header/card-header.component';
import { formatearCategoria } from '../categoria-display';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  imports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CardHeaderComponent,
    NgSelectModule,
  ],
  selector: 'app-crear-editar-listado-categoria',
  templateUrl: './crear-editar-listado-categoria.component.html',
  styleUrl: './crear-editar-listado-categoria.component.scss',
})
export class CrearEditarListadoCategoriaComponent implements OnInit {
  data = inject<{
    edit?: IListadoCategoria;
    idCliente?: string;
    categoria?: string;
    categorias?: string[]; // Array de categorías que se pueden crear
    titulo?: string; // Título personalizado para el diálogo
  }>(MAT_DIALOG_DATA);
  helper = inject(HelperService);
  dialogRef =
    inject<MatDialogRef<CrearEditarListadoCategoriaComponent>>(MatDialogRef);
  private service = inject(ListadoCategoriasService);

  public loading = false;
  public form?: FormGroup;
  public title?: string;

  public clientePropio = LoginService.getCliente();

  constructor() {
    // Hacer el diálogo draggeable
    this.dialogRef.disableClose = false;
  }

  private createForm() {
    // Categoría inicial: la del edit, la única disponible, o la primera del array
    const categoriaInicial =
      this.data?.edit?.categoria ||
      this.data.categoria ||
      this.data.categorias?.[0] ||
      null;

    this.form = new FormGroup({
      nombre: new FormControl(this.data?.edit?.nombre, [Validators.required]),
      idCliente: new FormControl(this.data.idCliente || this.clientePropio._id),
      categoria: new FormControl(categoriaInicial, Validators.required),
      global: new FormControl(this.data?.edit?.global ?? false),
    });
  }

  public async onSubmit() {
    this.loading = true;
    try {
      const data = this.form?.getRawValue();
      let res;
      if (this.data?.edit?._id) {
        res = await this.service.update(this.data.edit._id, data);
        this.helper.notifSuccess('Actualizado correctamente');
      } else {
        res = await this.service.create(data);
        this.helper.notifSuccess('Creado correctamente');
      }
      this.dialogRef.close(res);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
    this.loading = false;
  }

  public formatearCategoria(cat: string): string {
    return formatearCategoria(cat);
  }

  public formatearCategoriaMinuscula(cat: string): string {
    return formatearCategoria(cat).toLowerCase();
  }

  async ngOnInit() {
    if (this.data.edit?._id) {
      this.title = `Editar: ${this.data.edit.nombre}`;
    } else if (this.data.titulo) {
      this.title = this.data.titulo;
    } else {
      // Generar título según categorías disponibles
      if (this.data.categorias?.length === 1) {
        this.title = `Crear ${this.formatearCategoriaMinuscula(this.data.categorias[0])}`;
      } else if (this.data.categorias?.length) {
        const categoriasText = this.data.categorias
          .map((c) => this.formatearCategoriaMinuscula(c))
          .join(', ');
        this.title = `Crear ${categoriasText}`;
      } else if (this.data.categoria) {
        this.title = `Crear ${this.formatearCategoriaMinuscula(this.data.categoria)}`;
      } else {
        this.title = 'Crear o editar categoría';
      }
    }
    this.createForm();
  }
}
